export default "__VITE_PUBLIC_ASSET__88724874__"